module.exports = __webpack_public_path__ + "img/sm-sacageweaBlind.74c7af83.jpg";